import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportSpecification } from '@microsec/models';
import { BaseComponent } from '@ids-components';
import { CardComponent, CommonTableComponent } from '@microsec/components';
import { ConstantPipe } from '@ids-pipes';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

const FIELDS = {
  port: 'Port',
  name: 'Name',
  protocol: 'Protocol',
  reason: 'Reason',
  state: 'State',
  product: 'Product',
  version: 'Version',
  ostype: 'OS Type',
  conf: 'Conf',
  cpe: 'CPE',
};

@Component({
  selector: 'app-device-services',
  templateUrl: './device-services.component.html',
  styleUrls: ['./device-services.component.scss'],
  imports: [CommonModule, ButtonModule, CardComponent, CommonTableComponent],
  providers: [ConstantPipe],
})
export class DeviceServicesComponent extends BaseComponent implements OnInit {
  isLoading = false;

  _device = false;

  get device() {
    return this._device;
  }

  @Input() set device(value: any) {
    this._device = value;
    if (!!this._device) {
      this.getMappedServices();
    }
  }

  values: any[] = [];

  cols: any[] = [
    { field: 'port', header: 'Port', width: 7 },
    { field: 'name', header: 'Name', width: 15 },
    { field: 'protocol', header: 'Protocol', width: 10 },
    { field: 'reason', header: 'Reason', width: 10 },
    { field: 'state', header: 'State', width: 8 },
    { field: 'product', header: 'Product', width: 10 },
    { field: 'version', header: 'Version', width: 10 },
    { field: 'ostype', header: 'OS Type', width: 13 },
    { field: 'conf', header: 'Conf', width: 7 },
    { field: 'cpe', header: 'CPE', width: 13 },
  ];

  @ViewChild('dt') dt!: CommonTableComponent;

  constructor(private constantPipe: ConstantPipe) {
    super();
  }

  async ngOnInit() {
    await this.prepareConfigs();
  }

  getMappedServices() {
    const services = ((this.device.services as any[]) || [])?.map((service) => ({
      ...service,
      protocol: this.constantPipe.transform(service.protocol, 'detected-device-interface'),
    }));
    const nmapServices = ((this.device.nmap?.host?.services as any[]) || [])?.map((service) => ({
      port: service['@portid'],
      name: service.service?.['@name'],
      protocol: this.constantPipe.transform(service['@protocol'], 'detected-device-interface'),
      reason: service.state?.['@reason'],
      state: service.state?.['@state'],
      product: service.service?.['@product'],
      version: service.service?.['@version'],
      ostype: service.service?.['@ostype'],
      conf: service.service?.['@conf'],
      cpe: Array.isArray(!!service.service?.['cpe']) ? service.service['cpe'].join(', ') : service.service?.['cpe'],
    }));
    const values = this.util.sortObjectArray([...services, ...nmapServices], 'name');
    this.values = values;
  }

  openGenerateReportDialog() {
    const onGenerateReport = (specification: ReportSpecification) => {
      if (!!specification) {
        this.dt.generateReportDialog.exportReport(specification.data as any, `device_${this.device.id}_services`);
      }
    };
    this.dt.generateReportDialog.open(onGenerateReport, FIELDS, this.cols, [], this.values);
  }
}
